/* vp-panel-fix.js -- corrects nutrition facts vp-pdp-2.js has wrong or missing.

   vp-pdp-2.js carries a hardcoded FACTS map keyed by flavour name with no size
   dimension, so a flavour whose 25-serving bag has sold out still renders the
   25-serving label, calories and scoop weight on what is now a 15-serving
   product. Two entries are currently wrong:

     Dole Whip(R) Pineapple   panel:null          -> no label at all, prints the
                                                     "has not been published yet" copy
     Dole Whip(R) Strawberry  2024 25-serving label, cal 130, scoop 34g
                              -> the 15-serving bag is a DIFFERENT FORMULA:
                                 cal 140, scoop 35.8g, goMCT not goCOCOA

   FACTS lives inside that file's IIFE and cannot be reached from out here, so
   this corrects what was rendered instead. Every override is gated on the size
   actually on screen, so if a 25-serving bag comes back in stock it keeps its
   own 25-serving label rather than being handed the 15.

   TEMPORARY. The real fix is two lines in assets/vp-pdp-2.js (lines 46 and 52);
   better still, have sections/vp-pdp-2.liquid emit `panel` from
   custom.variant_full_ingredients_image and delete FACTS. Once either lands,
   delete this file and its <script> tag in the claude-4 template. */
(function () {
  "use strict";

  var CDN = "https://cdn.shopify.com/s/files/1/0090/0192/6735/files/";

  /* flavour (lowercased) -> the facts for ONE bag size */
  var OVERRIDES = {
    "dole whip® pineapple": {
      size: "15", cal: "140", scoop: "37.2g",
      panel: CDN + "Dole_Pineapple_15_Serv_Vegan.png?v=1791060266"
    },
    "dole whip® strawberry": {
      size: "15", cal: "140", scoop: "35.8g",
      panel: CDN + "15_Srv_Dole_Strawberry_Vegan.png?v=1791067368"
    }
  };

  var bens = document.getElementById("vpBens");
  var scroll = document.getElementById("vpNldScroll");
  var flavEl = document.getElementById("vpFlav");
  if (!bens && !scroll) return;

  /* #vpFlav reads "DOLE WHIP® PINEAPPLE · 15 SERVINGS" -- the only place both
     the flavour and the rendered size are available outside the dialog. */
  function current() {
    var t = (flavEl && flavEl.textContent || "").trim();
    if (!t) return null;
    var size = (t.match(/(\d+)\s*SERVING/i) || [])[1] || "";
    var name = t.split("·")[0].trim().toLowerCase();
    var o = OVERRIDES[name];
    return o && o.size === size ? o : null;
  }

  /* Writes are skipped when the value already matches, so the observers settle
     instead of retriggering on our own mutations. */
  function set(node, text) {
    if (node && node.textContent !== text) node.textContent = text;
  }

  function fixMosaic() {
    var o = current();
    if (!o || !bens) return;
    set(bens.querySelector("h4"), "per scoop · " + o.scoop);
    var cal = bens.querySelectorAll(".vp-bengrid > div")[1];
    if (cal) set(cal.querySelector("b"), o.cal);
  }

  function fixModal() {
    if (!scroll) return;
    var title = scroll.querySelector("#vpNlTitle");
    if (!title) return;
    var name = (title.textContent || "").trim();
    var o = OVERRIDES[name.toLowerCase()];
    if (!o) return;

    var meta = scroll.querySelectorAll(".vp-nl-meta dd");
    /* second dd is "N per bag" -- the dialog's own statement of the size */
    var size = ((meta[1] && meta[1].textContent || "").match(/(\d+)/) || [])[1] || "";
    if (size && size !== o.size) return;

    set(meta[0], "1 scoop (" + o.scoop + ")");
    var st = scroll.querySelector(".vp-nl-st span b");
    set(st, o.cal);

    var img = scroll.querySelector(".vp-nl-facts img");
    if (img) {
      if (img.getAttribute("src") !== o.panel) img.setAttribute("src", o.panel);
      return;
    }

    /* no panel rendered at all -- rebuild the success branch's markup */
    var none = scroll.querySelector(".vp-nl-none");
    if (!none) return;

    var facts = document.createElement("div");
    facts.className = "vp-nl-facts";
    var el = document.createElement("img");
    el.src = o.panel;
    el.alt = "Nutrition facts, " + name;
    el.loading = "lazy";
    facts.appendChild(el);

    var cap = document.createElement("p");
    cap.className = "vp-nl-cap";
    cap.textContent =
      "Label artwork for the " + o.size + "-serving bag. Values are per 1 scoop.";

    none.parentNode.replaceChild(cap, none);
    cap.parentNode.insertBefore(facts, cap);
  }

  function fix() { fixMosaic(); fixModal(); }

  /* Both hosts have innerHTML rewritten on every flavour change and on each
     dialog open, so observe rather than run once. */
  [bens, scroll].forEach(function (host) {
    if (host) new MutationObserver(fix).observe(host, { childList: true, subtree: true });
  });
  if (flavEl) new MutationObserver(fix).observe(flavEl, { childList: true, characterData: true, subtree: true });
  fix();
})();
